import { Component, Input, OnInit, Output, EventEmitter, inject } from '@angular/core';
import { Question } from './question';
import { faPaperPlane, faArrowRightLong } from '@fortawesome/pro-solid-svg-icons';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ContestAttemptAnswerDto, ContestAttemptDto } from 'src/app/models/contest-attempt-dto';
import { ContestAttemptService } from 'src/app/service/contest-attempt.service';
import { take } from 'rxjs';


@Component({
    selector: 'question',
    templateUrl: './question.component.html',
    styleUrls: ['./question.component.scss'],
    providers: [MatProgressBarModule],
    standalone: false
})
export class QuestionComponent {
    @Input() questionList!: Question[];
    @Input() contestAttemptDto!: ContestAttemptDto | null;
    @Output() lastQuestion = new EventEmitter();
    question!: Question;
    questionIndex: number = 0;
    questionCounter: number = 1;
    entryAnswer: number = 0;
    showModal: boolean = false;
    showAnswer: boolean = false;
    faPaperPlane = faPaperPlane;
    faArrowRightLong = faArrowRightLong;
    progress = 0;

    private contestAttemptService = inject(ContestAttemptService);

    lastQuestionClick() {
        /*console.log("Emitting to Contest Component!");*/
        this.lastQuestion.emit();
    }

    ngOnInit() {
        this.question = this.questionList[this.questionIndex];
        this.questionCounter = this.questionIndex + 1;
        this.updateProgress();
    }

    showFeedback(): void {
        // Guard: must have an attempt and a selected answer
        const attemptId = this.contestAttemptDto?.contestAttemptId;


        // Find the selected answer object
        const selected = this.question?.questionAnswers?.find(
            a => a.questionAnswerId == this.entryAnswer
        );
        if (!selected) {
            return;
        }

        if (attemptId && this.entryAnswer) {
            // Build DTO (createdAtUtc from client; server can override if desired)
            const dto: ContestAttemptAnswerDto = {
                contestAttemptAnswerId: 0,
                contestAttemptId: attemptId,
                questionId: this.question.questionId,
                answerId: this.entryAnswer,
                createdAtUtc: new Date().toISOString()
            };

            // Persist answer (fire-and-forget UI; move UI updates into next: if you want to wait for success)
            this.contestAttemptService.saveContestAttemptAnswer(dto)
                .pipe(take(1))
                .subscribe({
                    next: () => {
                        // success hook if needed
                    },
                    error: (err) => {
                    }
                });
        }

        // Update UI
        this.showAnswer = !!selected.correct;
        this.entryAnswer = 0;
        this.showModal = true;
    }

    onSubmit() {
        /*console.log("Question List Length: " + this.questionList.length + "\n" + "Current Index: " + this.questionIndex);*/

        if (this.questionList.length === this.questionCounter) {
            /*console.log("Submit check.");*/
            this.lastQuestionClick();
        } else {
            this.questionIndex = this.questionIndex + 1;
            this.questionCounter = this.questionCounter + 1;
            this.question = this.questionList[this.questionIndex];
        }

        this.showModal = false;
        this.showAnswer = false;
        this.updateProgress();

    }
    updateProgress() {
        this.progress = (this.questionCounter / this.questionList.length) * 100;
    }

}
